import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-version-tag',
  templateUrl: './version-tag.component.html',
  styleUrls: ['./version-tag.component.css'],
})
export class VersionTagComponent implements OnInit {
  constructor(
    private translateService: TranslateService,
    private cookieService: CookieService
  ) {}

  public versionName: string = '2.1.23';
  public persianDate: string = '1404/05/15';
  public date: string = '2025/08/06';
  public showDate: string = '';

  ngOnInit() {
    var cultureCookieValue = this.cookieService.get('Culture');
    if (cultureCookieValue == '') {
      this.cookieService.set('Culture', 'fa-IR');
    }
    if (cultureCookieValue == 'fa-IR') {
      this.showDate = this.persianDate;
    } else {
      this.showDate = this.date;
    }

    // const storedVersion = this.cookieService.get('Version');
    
    // if (this.versionName !== storedVersion) {
    //   this.cookieService.set('Version', this.versionName);
    //   // this.clearCasheAndReload();
    //   return;
    // }
    
    // const storedDate = this.cookieService.get('UpdateDate');
    
    // if (this.date !== storedDate) {
    //   this.cookieService.set('UpdateDate', this.date);
    //   // this.clearCasheAndReload();
    //   return;
    // }
  }

  // public clearCasheAndReload() {
  //   caches.keys().then(function (names) {
  //     names.forEach(function (name) {
  //       caches.delete(name);
  //     });

  //     window.location.reload();
  //   });
  // }
}


















































































































































































































































































































































































































































